/** biome-ignore-all lint/complexity/noBannedTypes: used intentionally to allow any non-null object */
import type { ConstValues } from './helpers.ts';

export const SortDirection = {
  ASC: 'asc',
  DESC: 'desc',
} as const;
export type SortDirection = ConstValues<typeof SortDirection>;

export interface SortCriteria {
  column: string;
  direction: SortDirection;
  valuePath?: Record<string, string[]>;
  sortableColumns: string[];
  isServerSortDisabled?: boolean;
}

export interface PaginationCriteria {
  pageSize: number;
  pageNumber: number;
  totalCount: number;
  hasMore?: boolean;
}

export const CriteriaDimension = {
  FILTERS: 'filters',
  SORT: 'sort',
  PAGINATION: 'pagination',
} as const;
export type CriteriaDimension = ConstValues<typeof CriteriaDimension>;

export type TableCriteria<
  T extends CriteriaDimension,
  FiltersT extends Record<string, unknown> = {},
> = T extends typeof CriteriaDimension.SORT
  ? SortCriteria
  : T extends typeof CriteriaDimension.PAGINATION
    ? PaginationCriteria
    : T extends typeof CriteriaDimension.FILTERS
      ? FiltersT
      : never;

export type AllTableCriteria<FiltersT extends Record<string, unknown> = {}> = {
  [dimension in CriteriaDimension]?: TableCriteria<dimension, FiltersT>;
};

export interface CriteriaChange<D extends CriteriaDimension, FiltersT extends Record<string, unknown> = {}> {
  dimension: D;
  value?: TableCriteria<D, FiltersT>;
}

export type ChangeCriteriaHandler<
  D extends CriteriaDimension = CriteriaDimension,
  FiltersT extends Record<string, unknown> = {},
> = (change: CriteriaChange<D, FiltersT>) => void;

export type ChangeSingleCriteriaAction<T extends CriteriaDimension, FiltersT extends Record<string, unknown> = {}> = (
  criteria: TableCriteria<T, FiltersT>
) => void;
